import { useCheckPaymentTerm } from 'pages/home/ribbon/components/sections/product/components/cod-payment/hooks';
import { useSelector } from 'react-redux';
import * as memberSelectors from 'pages/company-profile/controllers/selectors';

export const useCheckPaymentTermMonthAndMemberStatusCreditReview = () => {
  const { isMonthlyTerm } = useCheckPaymentTerm();
  const memberInfo = useSelector(memberSelectors.selectMemberProfile());

  return isMonthlyTerm && memberInfo?.status?.toLowerCase() === 'credit review';
};
